<template>
  <Row>
    <Col span="24">
      <b-table :columns="columns"
               :data="userRoleList"
               :loading="tableLoading"
               :open-action="false"
               :hide-actions="['editor', 'delete']"
               @on-view="viewHandler"
      >
      </b-table>
      <b-page
        :page="page1"
        :total="page1.total"
        :page-size="page1.pageSize"
        :page-num="page1.pageNum"
        :page-change="getUserRoleList"
      ></b-page>
    </Col>
    <RoleTree ref="roleTreeRef" :current-item="currentRole"/>
  </Row>
</template>

<script>
  import roleTableMixin from './roleTable'
  import RoleTree from './common/UserRoleTree'

  export default {
    name: 'UserRole',
    mixins: [roleTableMixin],
    components: { RoleTree },
    data () {
      return {
        platList: [],
        currentRole: null,
        userRoleList: []
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        let request = []
        request.push(this.getPlatList(), this.getUserRoleList())
        await Promise.all(request)
      },
      async getPlatList () {
        this.resetColumns()
        let { data } = await this.$http.queryPlatList()
        this.platList = data || []
        data = data.filter(it => it.status === 'Y')
        // 组合平台
        let subColumns = data.map(it => {
          return {
            title: it.name,
            code: it.code,
            render: (h, params) => {
              // let { row: { hasAuth } } = params
              // hasAuth = !hasAuth ? [] : hasAuth
              // let status = hasAuth.includes(it.code)
              // let modifyStatus = {
              //   platCode: it.code,
              //   userId: params.row.id
              // }
              return (
                // status ? (
                    <div style="display:flex;flexDirection:row;justifyContent:space-around:alignItems:center;">
                      <i-button type="primary" size="small"
                                nativeOnClick={this.roleManage.bind(this, params, it.code)}>角色管理
                      </i-button>
                    </div>
                  // )
                  // : (
                  //   <div>
                  //     <i-switch size="large" v-model={status} onOn-change={this.changeStatus.bind(this, modifyStatus)}>
                  //       <span slot="open" value="true">启用</span>
                  //       <span slot="close" value="false">禁用</span>
                  //     </i-switch>
                  //   </div>
                  // )
              )
            }
          }
        }, this)
        this.columns = [...this.columns, ...subColumns]
      },
      async getUserRoleList () {
        let query = Object.assign({}, this.page1)
        this.tableLoading = true
        let { data } = await this.$http.getUserRoleList(query)
        this.tableLoading = false
        let { results = [], totalRecord = 0 } = data
        this.userRoleList = results
        this.page1.total = totalRecord
      },
      viewHandler (params) {
        // console.log(params)
      },
      async changeStatus (modify, v) {
        let query = Object.assign({}, modify, { status: v })
        let { succ } = await this.$http.updateUserPlatRelation(query)
        if (succ) {
          this.init()
        }
      }
    }
  }
</script>

<style scoped>

</style>
